module.exports = __webpack_public_path__ + "static/media/sheroes-red-logo.3b978385.svg";